import React, {memo} from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {
    BASE_URL,
    IMG_PRODUCTS_PUBLIC_URL_SERVER,
    MORE_PRODUCTS_DETAILS_POST,
    PUBLIC_URL_SERVER
} from "../../../../apis";
import imgPlayS from "../../../../images/base-image-product.jpg";
// import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {useDispatch} from "react-redux";
import {actionRemoveItemInBasketCart, handelCloseModalShoppingCard} from "../../../../redux/actions/modals/modalShoppingCard";
import {
    actionChangeLoaderModalProduct,
    handelChangeDataSingleProduct, handelChangeSelectGradeModalProduct,
    handelOpenModalProduct
} from "../../../../redux/actions/modals/ModalProduct";
import axios from "axios";
import qs from "querystring";
import {Row, Col} from "react-bootstrap";
import {FaEdit, FaTrashAlt} from "react-icons/all";

const CardItemModalBasketCartProduct = (props) => {
    const {data, showEdit} = props;
    const {product} = data;
    const dispatch = useDispatch();


    const handelRemoveItem = () => {
        const buttonsOkCancel = Swal.mixin({
            customClass: {
                confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                cancelButton: 'base-btn-green-border btn btn-success',
            },
            buttonsStyling: false
        });
        buttonsOkCancel.fire({
            title: "حذف محصول",
            text: `آیا میخواهید ${product.name} از سبد خود را حذف کنید؟`,
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "بله",
            showCancelButton: true,
            cancelButtonText: 'انصراف',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(actionRemoveItemInBasketCart(product.gradeId));
            }
        });

    };

    const openModalProductForChange = () => {
        apiGetDataSingleProductForChange();
        dispatch(handelCloseModalShoppingCard());
        dispatch(handelOpenModalProduct());
    };
    const apiGetDataSingleProductForChange = () => {
        dispatch(actionChangeLoaderModalProduct(true));
        axios({
            method: 'post',
            url: BASE_URL + MORE_PRODUCTS_DETAILS_POST,
            data: qs.stringify({
                product: product.productId
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }).then((response) => {
            if (response.data.status === "ok") {
                dispatch(handelChangeDataSingleProduct(response.data.product, response.data.similar, response.data.options));
                for (const grade in response.data.product.grades) {
                    if (response.data.product.grades[grade].gradeId === product.gradeId) {
                        dispatch(handelChangeSelectGradeModalProduct({
                            ...response.data.product.grades[grade],
                            number_input: product.w_numbers
                        }, product.optionSelect));
                        break;
                    }
                }
            }
            dispatch(actionChangeLoaderModalProduct(false));
        });
    };

    return (
        <div className={'item-box-shopping-card'}>
            <div className={'fx-item-box-shopping-card'}>
                <div className={'img-box-shopping-card'}>
                    <LazyLoadImage
                        width={64}
                        height={64}
                        alt={product.name}
                        src={PUBLIC_URL_SERVER + IMG_PRODUCTS_PUBLIC_URL_SERVER + product.image}
                        placeholderSrc={imgPlayS}
                    />
                </div>
                <div className={'base-data-box-shopping-card'}>
                    <Row>
                        <Col xs={6}>
                            <div className={'title-box-shopping-card'}>
                                <h6 className={'m-0'}>{product.name ? product.name : 'نام محصول'}{product.forFoodPack ? ' (پکیج غذا)' : ''}</h6>
                                <p>{product.gradeTitle ? product.gradeTitle : 'gradeTitle'}</p>
                            </div>
                        </Col>
                        <Col xs={3}>
                            <div className={'unit-box-shopping-card'}>
                                <span>{product.w_numbers}</span>
                                <span className={'ml-1'}>{product.unit ? product.unit : 'واحد'}</span>
                            </div>
                        </Col>
                        <Col xs={3}>
                            <div className={'price-box-shopping-card'}>
                                <span>{product.price ?
                                    typeof product.price === "string" ? product.price : parseInt(product.price).toLocaleString()
                                    : 'price'} تومان</span>
                            </div>
                        </Col>
                    </Row>
                    {/*<div className={'data-box-shopping-card'}>
                    </div>*/}
                    {showEdit ?
                        <div className={'selector-item-box-shopping-card'}>
                            <div className={'base-selector-item-shopping-card'}>
                                <div onClick={openModalProductForChange}>
                                    <FaEdit className={'cm-icons-color-green'}/>
                                    <span>ویرایش</span>
                                </div>
                            </div>
                            <div className={'base-selector-item-shopping-card'}>
                                <div onClick={handelRemoveItem}>
                                    <FaTrashAlt className={'cm-icons-color-green'}/>
                                    <span>حذف محصول</span>
                                </div>
                            </div>
                        </div>
                        : ''}
                </div>
            </div>
        </div>
    );
};

export default memo(CardItemModalBasketCartProduct);
